'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastBody", {
    enumerable: true,
    get: function() {
        return ToastBody;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToastBody = require("./useToastBody");
const _renderToastBody = require("./renderToastBody");
const _useToastBodyStylesstyles = require("./useToastBodyStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToastBody = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToastBody.useToastBody_unstable)(props, ref);
    (0, _useToastBodyStylesstyles.useToastBodyStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToastBodyStyles_unstable')(state);
    return (0, _renderToastBody.renderToastBody_unstable)(state);
});
ToastBody.displayName = 'ToastBody';
